import * as React from "react"
import { RentalAdvert, Route, } from "../../../types/types";

type Props = {
  link: Route
}

export const CoronaPolicy = (props: Props) : JSX.Element => (
  <div className="box box--yellow box--slim">
    <div
      className="box__body"
      dangerouslySetInnerHTML={{__html: I18n.t('rental_adverts.corona_policy.display', { link: props.link.path})}}
    ></div>
  </div>
)
